/**
 * AdminServiceCommandPanel React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import { withStyles } from '@material-ui/core/styles';

// Material UI components
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';

// Material UI icons
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// application
import ControlledAccordion from '../base/ControlledAccordion';
import ObjectFieldSet from '../editing/ObjectFieldSet';


const serviceCommandFields = [
    {
        "id": "rebuildmediainfodatabasecommand",
        "name": "Medien-Info-Datenbank neu erstellen",
        "type": "command",
        "resturl": "/admin/mediainfodatabase/rebuild",
        "restmethod": "GET",
        "note": "Diese Operation kann nötig sein nach manuellen Zugriffen auf das Dateisystem und abhängig von der Größe der Medienbibliothek mehrere Minuten oder Stunden dauern. Währenddessen ist der Betrieb des Systems unter Umständen blockiert."
    },
    {
        "id": "rebuildobjectreferencescommand",
        "name": "Objektabhängigkeiten neu analysieren",
        "type": "command",
        "resturl": "/admin/objectreferences/rebuild",
        "restmethod": "GET",
        "note": "Diese Operation kann nötig sein nach manuellen Eingriffen in die Datenbank."
    }
];

const developerCommandFields = [
    {
        "id": "convertdatabaseidscommand",
        "name": "Datenbank-IDs konvertieren",
        "type": "command",
        "resturl": "/admin/database/convert/ids",
        "restmethod": "POST",
        "note": "Diese Operation muss nur einmalig durchgeführt werden, um alte IDs an das neue Format anzupassen."
    }
];


/**
 * Panel for service commands
 *
 * @author Jens Gruschel
 */
class AdminServiceCommandPanel extends React.Component {

    render() {

        const {classes, canExecuteDeveloperCommands} = this.props;

        return <ControlledAccordion className={classes.accordion} defaultExpandedPanelKey="servicecommands">

            <ExpansionPanel key="servicecommands">

                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography>Service-Befehle</Typography>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                    <ObjectFieldSet
                        fieldDefinitions={serviceCommandFields}
                        objectId={null}
                        objectFields={{}}
                        readOnly={true}
                        scope={[]}
                        onObjectValueChange={value => {}}
                    />
                </ExpansionPanelDetails>

            </ExpansionPanel>

            {canExecuteDeveloperCommands && <ExpansionPanel key="developercommands">

                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography>Developer-Befehle</Typography>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                    <ObjectFieldSet
                        fieldDefinitions={developerCommandFields}
                        objectId={null}
                        objectFields={{}}
                        readOnly={true}
                        scope={[]}
                        onObjectValueChange={value => {}}
                    />
                </ExpansionPanelDetails>

            </ExpansionPanel>}

        </ControlledAccordion>;
    }
}

const styles = theme => ({
    accordion: {
        width: '100%'
    }
});

const mapStateToProps = state => {
    const privileges = state.authorization.userPrivileges;
    return {
        canExecuteDeveloperCommands: privileges.executeDeveloperCommands,
    };
};

export default connect(mapStateToProps)(withStyles(styles)(AdminServiceCommandPanel));